import { AccountingSheetDsdConvertPage } from "@/components/team-workspace/accounting-sheet-dsd-convert";
import { LeftSidebar } from "@/components/app-shell";

const MainContent = () => {
  return (
    <div className="flex flex-1 h-full flex-col items-center self-stretch overflow-y-auto relative">
      <AccountingSheetDsdConvertPage />
    </div>
  );
};

const AccountingSheetDsdConvertWorkspace = () => {
  return (
    <div className="inline-flex w-full h-full items-center relative">
      <LeftSidebar activeMenu="accounting-sheet-dsd-convert" />
      <MainContent />
    </div>
  );
};

export default AccountingSheetDsdConvertWorkspace;
